module.exports = __webpack_public_path__ + "static/media/game_cover_punball.00b66a13.png";